import { ThemeProvider } from '@mui/material/styles';
import theme from './styles/theme';
import './App.css';
import { Signin } from './pages/auth/Signin';
import { ForgotPassword } from './pages/auth/ForgotPassword';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ResetPassword } from './pages/auth/ResetPassword';
import { Dashboard } from './pages/dashboard';
import { Error404 } from './pages/errors/Error404';
import { AuthProvider } from './contexts/AuthContext';
import { Signup } from './pages/auth/Signup';
import { BuyCredit } from './pages/buy-credit';
import { BuyCreditThankYou } from './pages/buy-credit/ThankYou';
import { API } from './pages/api';
import { Reports } from './pages/reports';
import { Invoices } from './pages/invoices';
import Test from './pages/test';
import { BuyCreditComplete } from './pages/buy-credit/Complete';
import { Corrections } from './pages/corrections';
import { Documentation } from './pages/documentation';
import { Integrations } from './pages/integrations';
import { User } from './pages/user';
import { SessionData } from './pages/sessions';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/buy-credit/:credit_id" element={<BuyCredit />} />
            <Route
              path="/buy-credit/:credit_id/checkout-complete"
              element={<BuyCreditComplete />}
            />
            <Route
              path="/buy-credit/thank-you"
              element={<BuyCreditThankYou />}
            />
            <Route path="/signin" element={<Signin />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/password/forgot" element={<ForgotPassword />} />
            <Route path="/password/reset" element={<ResetPassword />} />
            <Route path="/api" element={<API />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/invoices" element={<Invoices />} />
            <Route path="/test" element={<Test />} />
            <Route path="/corrections/*" element={<Corrections />} />
            <Route path="/session_data" element={<SessionData />} />
            <Route path="/documentation" element={<Documentation />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/user" element={<User />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
